import React from "react";

import { Box } from "@mui/material";

import ChildSeatChip from "./ChildSeatChip";
import { ChildSeatVariant } from "types";

const { RearFacing, ForwardFacing, Booster } = ChildSeatVariant;

type ChildSeatsNoteBlockProps = {
  boosterSeatQuantity?: number;
  forwardFacingSeatQuantity?: number;
  rearFacingSeatQuantity?: number;
  isOld?: boolean;
};

function ChildSeatsNoteBlock(props: ChildSeatsNoteBlockProps) {
  const {
    rearFacingSeatQuantity,
    boosterSeatQuantity,
    forwardFacingSeatQuantity,
    isOld,
  } = props;

  return (
    <Box display="flex" flexWrap="wrap" columnGap={1} mt={1}>
      <ChildSeatChip
        variant={Booster}
        quantity={boosterSeatQuantity}
        isOld={isOld}
      />
      <ChildSeatChip
        variant={ForwardFacing}
        quantity={forwardFacingSeatQuantity}
        isOld={isOld}
      />
      <ChildSeatChip
        variant={RearFacing}
        quantity={rearFacingSeatQuantity}
        isOld={isOld}
      />
    </Box>
  );
}

export default ChildSeatsNoteBlock;
